/* eslint-disable react/display-name */
import { PageLayoutGetter } from '@base/components/src/LayoutChooser/types';
import { ReactNode } from 'react';

import RootLayout from '../RootLayout';

import { LayoutPageProps, ShoppingCartLayoutProps } from './types';

const ShoppingCartLayout = ({
  children,
  seoComponent,
  freeSHTotalRetail,
  layoutProps,
}: React.PropsWithChildren<ShoppingCartLayoutProps>) => (
  <>
    {seoComponent ? seoComponent : null}
    <RootLayout {...layoutProps} searchComponent menuComponent freeSHTotalRetail={freeSHTotalRetail}>
      {children}
    </RootLayout>
  </>
);

export const RenderShoppingCartLayout = (seoComponent: ReactNode): PageLayoutGetter<LayoutPageProps> => {
  return (page: ReactNode, props: any) => (
    <ShoppingCartLayout layoutProps={props} seoComponent={seoComponent} freeSHTotalRetail={props.freeSHTotalRetail}>
      {page}
    </ShoppingCartLayout>
  );
};

export default ShoppingCartLayout;
